export const SESSION_ID = +Math.random().toString().slice(2);
